import { getEnvVariable } from "utilities/env";
import { links } from "utilities/links";

const OKTAClientId = getEnvVariable("REACT_APP_OKTA_CLIENT_ID");
const OKTADirectoryId = getEnvVariable("REACT_APP_OKTA_PROVIDER_APP_URL");

export const oktaConfig = {
  clientId: `${OKTAClientId}`,
  issuer: `${OKTADirectoryId}`,
  redirectUri: links.oktaLoginCallback,
  pkce: true,
  disableHttpsCheck: false,
};
